module.exports = __webpack_public_path__ + "img/s2P28.93a35b5e.png";